import { styled } from "@linaria/react";

const FormField = styled.div`
  display: flex;
  flex-direction: column;
  & > input,
  & > .p-dropdown {
    width: 100%;
  }
  &:focus,
  &:focus-within {
    .form-field-error {
      color: transparent;
      transition-delay: 1.5s;
    }
  }
`;
const Header = styled.span`
  user-select: none;
  margin-bottom: 0.5rem;
  display: inline-flex;
  align-items: center;
  &:first-letter {
    text-transform: capitalize;
  }
  & > .info-tooltip {
    margin-left: 0.5rem;
  }
`;
const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;
export const FormFieldStyle = { FormField, Header, FieldWrapper };
